import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone, FaEnvelope, FaClock, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaSearch, FaWhatsapp } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  return (
    <>
      <div id="main-header-container" className="fixed w-full z-50 top-0 left-0 transition-all duration-300 shadow-lg">
        {/* Top Bar */}
        <div className={`w-full bg-[#22446b] text-white border-b border-white/10 transition-all duration-500 ease-in-out overflow-hidden ${
          isScrolled ? 'max-h-0' : 'max-h-[50px] py-3 lg:block hidden'
        }`}>
          <div className="container mx-auto px-6 lg:px-8">
            <div className="flex justify-between items-center text-sm font-opensans">
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
                  <FaEnvelope className="text-[#22446b]" />
                  <span>info@sutrasync.com</span>
                </div>
                <div className="flex items-center space-x-2">
                  <FaClock className="text-white/80" />
                  <span>Mon - Fri: 9:00 AM - 6:00 PM</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Header - Now part of the wrapper */}
        <div className="w-full bg-white relative">
          <div className={`container mx-auto px-6 lg:px-8 transition-all duration-300 ${
            isScrolled ? 'py-0.5' : 'py-1'
          }`}>
            <div className="flex justify-between items-center">
              {/* Logo */}
              <Link to="/" className="flex items-center space-x-3 group">
                {/* Sutrasync Logo */}
                <div className="flex items-center">
                  {/* Logo Image */}
                  <div className="w-auto mr-3 transition-all duration-300">
                    <img 
                      src="/logo.png" 
                      alt="SutraSync Logo" 
                      className="h-16 w-auto object-contain group-hover:opacity-80 transition-opacity duration-300"
                    />
                  </div>
                </div>
              </Link>

              {/* Desktop Navigation */}
              <nav className="hidden lg:flex items-center space-x-8">
                {[
                  { name: 'Home', href: '/' },
                  { name: 'Services', href: '/services' },
                  { name: 'About', href: '/about' },
                  { name: 'Blog', href: '/blog' },
                  { name: 'Contact', href: '/contact' }
                ].map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`relative font-rajdhani font-bold text-lg transition-all duration-300 group py-2 ${
                      location.pathname === item.href
                        ? 'text-[#338edc]'
                        : 'text-[#22446b] hover:text-[#338edc]'
                    }`}
                  >
                    {item.name}
                    <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-[#338edc] transition-all duration-300 group-hover:w-full ${
                      location.pathname === item.href ? 'w-full' : ''
                    }`}></span>
                  </Link>
                ))}
              </nav>

              {/* Right Side Actions */}
              <div className="hidden lg:flex items-center space-x-6">
                <button className="text-[#338edc] hover:text-[#338edc] transition-colors">
                  <FaSearch size={20} />
                </button>

                <div className="flex items-center space-x-3 text-[#22446b]">
                  <div className="w-10 h-10 rounded-full border border-[#338edc] flex items-center justify-center text-[#338edc]">
                    <FaPhone className="text-sm" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-opensans text-[#22446b]">Call Us details</span>
                    <span className="text-sm font-rajdhani font-bold text-[#22446b]">+91 7483961283</span>
                  </div>
                </div>
                
                {/* Social Media Icons - Desktop Only */}
                <div className="hidden xl:flex items-center space-x-3">
                  <a href="https://www.facebook.com/share/1GLCUxZKbX/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-[#1877F2] flex items-center justify-center hover:bg-[#0d5dbf] text-white transition-all duration-300">
                    <FaFacebookF size={14} />
                  </a>
                  <a href="https://www.linkedin.com/company/sutra-sync-technology" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-[#0A66C2] flex items-center justify-center hover:bg-[#004182] text-white transition-all duration-300">
                    <FaLinkedinIn size={14} />
                  </a>
                  <a href="https://www.instagram.com/sutrasync_techonologies/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] flex items-center justify-center hover:opacity-90 text-white transition-all duration-300">
                    <FaInstagram size={14} />
                  </a>
                  <a href="https://wa.me/917483961283" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center hover:bg-[#1da851] text-white transition-all duration-300">
                    <FaWhatsapp size={16} />
                  </a>
                </div>
              </div>

              {/* Mobile menu button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="lg:hidden p-2 text-[#338edc] hover:text-[#338edc] transition-colors"
              >
                {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full left-0 top-full shadow-xl">
              <div className="container mx-auto px-6 py-6">
                
              
                
                <nav className="flex flex-col space-y-4">
                  {[
                    { name: 'Home', href: '/' },
                    { name: 'Services', href: '/services' },
                    { name: 'About', href: '/about' },
                    { name: 'Blog', href: '/blog' },
                    { name: 'Contact', href: '/contact' }
                  ].map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setIsMenuOpen(false)}
                      className={`font-rajdhani font-bold text-lg py-2 border-b border-gray-50 flex justify-between ${
                        location.pathname === item.href
                          ? 'text-[#338edc]'
                          : 'text-[#22446b] hover:text-[#338edc]'
                      }`}
                    >
                      <span>{item.name}</span>
                    </Link>
                  ))}
                </nav>
                
                {/* Mobile Social Media Icons */}
                <div className="flex items-center justify-center space-x-4 mt-6 pt-6 border-t border-gray-100">
                  <a href="https://www.facebook.com/share/1GLCUxZKbX/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center hover:bg-[#0d5dbf] text-white transition-all duration-300">
                    <FaFacebookF size={16} />
                  </a>
                  <a href="https://www.linkedin.com/company/sutra-sync-technology" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#0A66C2] flex items-center justify-center hover:bg-[#004182] text-white transition-all duration-300">
                    <FaLinkedinIn size={16} />
                  </a>
                  <a href="https://www.instagram.com/sutrasync_techonologies/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] flex items-center justify-center hover:opacity-90 text-white transition-all duration-300">
                    <FaInstagram size={16} />
                  </a>
                  <a href="https://wa.me/917483961283" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center hover:bg-[#1da851] text-white transition-all duration-300">
                    <FaWhatsapp size={18} />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;